module.exports = __webpack_public_path__ + "assets/img/sidemenu-item06.5dfa1efc.svg";